import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ConceptSelection, RefLink, RefLinkType} from '@twpub/core/models';
import {NgClass} from '@angular/common';

@Component({
  selector: 'pub-internal-link-render',
  templateUrl: './internal-link-render.component.html',
  styleUrls: ['./internal-link-render.component.scss'],
  standalone: true,
  imports: [NgClass]
})
export class InternalLinkRenderComponent implements OnInit {
  @Input() refLink!: RefLink;
  @Input() text: string = '';

  @Output() conceptSelected = new EventEmitter<ConceptSelection>();

  linkText: string = '';

  ngOnInit(): void {
    this.linkText = (this.refLink.type === RefLinkType.TERM_LINK_DYNAMIC_TYPE ? this.refLink.dynamicText : this.text) || '';
  }

  onClick(event: MouseEvent, refLink: RefLink): void {
    event.preventDefault();
    event.stopPropagation();
    if (!refLink.invalid) {
      const conceptId = refLink.conceptId;
      const termId = refLink.termId;
      this.conceptSelected.emit({conceptId, termId});
    }
  }
}
